export const GET_LP_PAGE = 'getLpPage'
export const GET_CLIENT_LP_PAGE = 'getClientLpPage'
